module.exports = __webpack_public_path__ + "static/img/free.0b55321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/free.png
// module id = J9Dj
// module chunks = 1